import script from "./payroll-close-period-confirm-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-close-period-confirm-modal.vue?vue&type=script&setup=true&lang=js"

import "./payroll-close-period-confirm-modal.vue?vue&type=style&index=0&id=a98dbb82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a98dbb82"]])

export default __exports__